import React, {useState} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Tab_01 from "../../images/services/dt/Development-architecture-design.webp";
import Tab_02 from "../../images/services/dt/Cloud-migration-deployment.webp";
import Tab_03 from "../../images/services/dt/Advanced-intelligent-solutions.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Technologysec(props) {
    const [activeTab, setActiveTab] = useState(1);

    function displayTab(tabNumber) {
        setActiveTab(tabNumber);
    }

    return (
        <>
            <div className="tekgriping_section p-100">
                <Container className="h-100">
                    <Row className="h-100">
                        <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                            <div className="example" data-text="Our Forte">
                                <h2>Our Forte</h2>
                            </div>
                            <p>We help your business achieve a successful digital transformation that drives growth,
                                innovation, and efficiency.</p>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <div className="tekgrip_flex">
                                <div className="tekgrip_title">
                                    <h5>70%
                                        <span>Usage</span></h5>
                                </div>
                                <div className="tekgrip_title">
                                    <h5>17%
                                        <span>CAGR</span></h5>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <h3 onClick={() => {
                                displayTab(1)
                            }} className={`tabs ${activeTab === 1 ? 'active' : ''}`}>
                                <div className="tab_namee">Development & architecture design</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(2)
                            }} className={`tabs ${activeTab === 2 ? 'active' : ''}`}>
                                <div className="tab_namee">Cloud migration & deployment</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(3)
                            }} className={`tabs ${activeTab === 3 ? 'active' : ''}`}>
                                <div className="tab_namee">Advanced intelligent solutions</div>
                            </h3>

                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="tekgrip_tabs_iamge tekrevol_dark_bg p-100">
                <Container className="h-100">
                    <Row className={activeTab === 1 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Development & Architecture Design</h2>
                                <p>TekRevol takes complete responsibility for the development and design of the
                                    architecture, covering all the aspects comprehensively. We deliver digital
                                    transformation solutions that enable startups and conventional businesses to
                                    seamlessly adopt the processes while striving to establish their footprint with
                                    systems that help you excel with authority.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Tab_01}
                                    effect="blur" alt="Tab_01" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 2 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Cloud Migration & Deployment</h2>
                                <p>Cloud technology helps us serve businesses better by implementing solutions with a
                                    forward-thinking approach. Our cloud migration and deployment services set the
                                    course for scalability, organizational excellence, and better network security.
                                    TekRevol delivers on its promise to help its clients go digital by moving toward the
                                    cloud.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Tab_02}
                                    effect="blur" alt="Tab_02" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 3 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Advanced Intelligent Solutions</h2>
                                <p>Systems and solutions we build for our clients provide not only strategic assistance
                                    but also help at the tactical level for better navigations. As part of our digital
                                    transformation solutions, we rely heavily on artificial intelligence and machine
                                    learning to enable operational superiority and efficiency.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Tab_03}
                                    effect="blur" alt="Tab_03" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>

                </Container>
            </div>
        </>
    );
}

export default Technologysec;